var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "",
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.seaport.tabPort.tabName"),
                    name: "port",
                    no: "port"
                  }
                },
                [_c("port", { ref: "port" })],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("baseInfo.seaport.tabEdiPort.tabName"),
                    name: "ediPort",
                    no: "ediPort"
                  }
                },
                [_c("edi-port", { ref: "ediPort" })],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("baseInfo.seaport.tabAmsPort.tabName"),
                    name: "amsPort",
                    no: "amsPort"
                  }
                },
                [_c("ams-port", { ref: "ams-port" })],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: {
                position: "fixed",
                "z-index": "9999",
                height: "100%",
                width: "100%",
                "background-color": "#2d3a4b22",
                display: "flex",
                "justify-content": "center",
                "align-items": "center"
              }
            },
            [
              _c("svg-icon", {
                staticStyle: { "font-size": "60px" },
                attrs: { "icon-class": "loading-bars" }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }